<div class="main-container flex flex-column gap-spacing-2xl">
  <div class="flex flex-column gap-spacing-2xl">
    <div class="flex flex-column gap-spacing-2xl">
      <p-table
        #dt1
        [value]="gridData()"
        [columns]="gridColumn"
        dataKey="name"
        [rows]="rows()"
        [first]="first()"
        [rowsPerPageOptions]="rowsPerPageOptions"
        [loading]="loading"
        [paginator]="true"
        [totalRecords]="totalRecords()"
        (onPage)="onPage($event)"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {{
          totalRecords()
        }} entries"
        [scrollable]="true"
        [className]="'table-main-mode'"
        [(selection)]="selectedItems"
        scrollHeight="calc(75vh - 150px)"
        (onFilter)="getInternalFilterValues($event, dt1)"
        lazy="true"
      >
        <ng-template pTemplate="caption">
          <st-grid-filters
            (applyFilters)="getFilterValues($event, dt1)"
            (filtersCleared)="gridData.set([]); resetFiltersValue(dt1)"
            sectionTitle="Ride Tracking"
            [filters]="this.filtersData"
            [expanded]="true"
            [filterActionsPlacement]="'end'"
            [AllowUpdateFilterControls]="true"
            [filterToggleIcon]="'icon-funnel-simple'"
            [showTitleTag]="true"
            [customHeaderContentWithFilterButton]="true"
            [updatedControls]="updatedFiltersData()"
            [requireCompleteDateRange]="false"
          >
            <div ngProjectAs="st-filters-section-header-custom">
              <span class="p-input-icon-left">
                <i class="icon-magnifying-glass"></i>
                <input
                  pInputText
                  type="text"
                  (debouncedInput)="getSearchValue($event)"
                  placeholder="Search"
                  [(ngModel)]="searchValue"
                  appDebounceInput
                />
              </span>
            </div>
          </st-grid-filters>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr class="empty-grid-tmplate">
            <td [attr.colspan]="columns.length + 2">
              <div
                class="flex flex-column gap-spacing-xs justify-content-center align-items-center w-full h-10rem"
              >
                <em
                  class="icon-files display-small-medium text-light-color"
                ></em>
                <span class="label-large-regular text-light-color">{{
                  noDataMessage()
                }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header" let-rowColumns>
          @if (gridData().length || isInternalFilterActive) {
            <tr>
              <!-- Index Column -->
              <th scope="col" class="text-center" [style.width]="'44px'">
                <div class="th-container flex justify-content-center">
                  <span class="w-auto">
                    <span class="grid-hash-svg">
                      <img src="assets/icons/Hash.svg" alt="" />
                    </span>
                  </span>
                </div>
              </th>
              @for (col of rowColumns; track col) {
                <th
                  [pSortableColumn]="col.field"
                  pReorderableColumn
                  [hidden]="!col.showColumn"
                  scope="col"
                >
                  <div class="th-container flex gap-2">
                    <div
                      class="flex-1 flex gap-spacing-xs justify-content-start"
                    >
                      <span class="w-auto text-sm font-semibold">{{
                        col.name
                      }}</span>
                      <div
                        (click)="onSortButtonClick(col.field, sortMenu, $event)"
                        (keydown.enter)="sortMenu.toggle($event)"
                        class="custom-sort-button"
                        [ngClass]="{
                          'active-sort':
                            filtersValues()?.sort_field === col.field,
                          'hover-sort':
                            activeSortMenuField() === col.field &&
                            !(filtersValues()?.sort_field === col.field),
                        }"
                      >
                        <em
                          class="body-medium-regular"
                          [ngClass]="getSortIcon(col.field)"
                        ></em>
                      </div>
                      <p-menu
                        #sortMenu
                        [model]="columnSortMenuItems"
                        [popup]="true"
                        appendTo="body"
                        (onHide)="onSortMenuHide()"
                      >
                        <ng-template let-item pTemplate="item">
                          <div
                            class="sort-item flex align-items-center gap-spacing-sm px-spacing-xl py-spacing-xs radius-md cursor-pointer"
                            [ngClass]="{
                              'selected-sort-item': isSelectedSort(item.label),
                            }"
                          >
                            <i [class]="item.icon"></i>
                            <span
                              [ngClass]="{
                                'label-large-medium': isSelectedSort(
                                  item.label
                                ),
                                'label-large-regular': !isSelectedSort(
                                  item.label
                                ),
                              }"
                            >
                              {{ item.label }}
                            </span>
                          </div>
                        </ng-template>
                      </p-menu>
                    </div>
                    @if (col.showFilter) {
                      <p-columnFilter
                        [type]="col.type"
                        [field]="col.field"
                        display="menu"
                        [showAddButton]="col.showAddButton"
                        [showOperator]="false"
                        [matchModeOptions]="getMatchModes(col.type)"
                      >
                        <ng-template pTemplate="filtericon">
                          <i class="icon-funnel-simple"></i>
                        </ng-template>
                      </p-columnFilter>
                    }
                  </div>
                </th>
              }
              <th
                alignFrozen="right"
                pFrozenColumn
                scope="col"
                [style.width]="'44px'"
              >
                <div
                  class="flex align-items-center justify-content-center relative"
                >
                  <st-multi-select-draggable
                    [items]="this.gridColumn"
                    [optionLabel]="'name'"
                    [(itemsModel)]="selectedGridColumns"
                    (itemsModelChange)="changeGridView()"
                  />
                </div>
              </th>
            </tr>
          }
        </ng-template>
        <ng-template
          pTemplate="body"
          let-rowData
          let-columns="columns"
          let-index="rowIndex"
        >
          <tr
            [ngClass]="{
              'p-datatable-row-selected': dt1.isRowExpanded(rowData),
            }"
          >
            <td [style.width]="'44px'">
              <span class="webkit-box-one-line label-large-regular">
                {{ rowData.index }}
              </span>
            </td>

            @for (col of columns; track col) {
              <td [hidden]="!col.showColumn">
                <!-- Specific Templates -->
                @switch (col.code) {
                  @case ("events") {
                    <div class="flex flex-wrap gap-spacing-xs">
                      @if (rowData.events && rowData.events.length) {
                        <app-telematics-events [events]="rowData.events" />
                      } @else {
                        <span>N/A</span>
                      }
                    </div>
                  }
                  @case ("driverId") {
                    <div class="flex flex-column gap-spacing-default">
                      <span class="label-large-regular text-primary-color">{{
                        rowData.driverId
                      }}</span>
                    </div>
                  }
                  @case ("distance") {
                    <div class="flex flex-column gap-spacing-default">
                      <span class="label-large-regular"
                        >{{ rowData.distance }} miles</span
                      >
                    </div>
                  }
                  @case ("percentage") {
                    <div class="flex flex-column gap-spacing-default">
                      <span class="label-large-regular">
                        @if (
                          rowData.percentage != null &&
                          rowData.percentage !== undefined
                        ) {
                          {{ rowData.percentage }}%
                        } @else {
                          No Data
                        }
                      </span>
                    </div>
                  }
                  @case ("dateOfService") {
                    <div class="flex flex-column gap-spacing-default">
                      <span class="label-large-regular">{{
                        rowData.dateOfService | date: "MMM dd, yyyy"
                      }}</span>
                    </div>
                  }
                  @case ("calculatedDuration") {
                    <div class="flex flex-column gap-spacing-default">
                      <span class="label-large-regular"
                        >{{ rowData.calculatedDuration }} minutes</span
                      >
                    </div>
                  }
                  <!-- Fallback for Other Fields -->
                  @default {
                    <span class="webkit-box-one-line">
                      {{ rowData[col.field] }}
                    </span>
                  }
                }
              </td>
            }
            <td
              class="text-center cursor-pointer"
              pFrozenColumn
              alignFrozen="right"
              [style.width]="'44px'"
            >
              <a
                icon="icon-dots-three-vertical cursor-pointer "
                (click)="customToggleMenu($event, menu, rowData, true)"
                ><i
                  class="icon-dots-three-vertical title-large-medium icon-brand-color"
                ></i
              ></a>

              <p-menu #menu [model]="subItems" [popup]="true" appendTo="body" />
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
